import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ApiGetSmsSubaccountListHistoryOptions, filterKey } from '@models/reseller/sms-history-detail';
import { ApiGetSubaccounts, Subaccount } from '@models/subaccount/subaccount';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ResellerHistoryService } from '@services/reseller-history.service';
import { SmsService } from '@services/sms.service';
import { SubaccountService } from '@services/subaccount.service';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { SmsDetailRenderComponent } from '@ui/components/atlas-grid/renderer/sms-detail-render/sms-detail-render.component';
import { creditsTypeIcon } from '@utils/constants';
import { formateDateTime } from '@utils/utils';
import { GridReadyEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime, finalize } from 'rxjs/operators';
import { HistoryDetailModalComponent } from './history-modal-detail/history-detail-modal.component';
import { User } from '../../../models/user';
import { UserService } from '../../../services/user.service';
import { LoaderService } from '@services/loader.service';

@Component({
  selector: 'wsb-reseller-history',
  templateUrl: './reseller-history.component.html',
  styleUrls: ['./reseller-history.component.scss'],
  animations: [
    trigger('gridIsLoaded', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),
      transition('hide => show', animate('150ms', style({ opacity: 1 }))),
      transition('show => hide', animate('150ms', style({ opacity: 0 })))
    ])
  ],
  standalone: false
})
export class ResellerHistoryComponent implements OnInit {
  @ViewChild('grid') grid: AtlasGridComponent;
  @ViewChild('modalExportSmsList') modalExportSmsList;
  @ViewChild('modalSuccessExport') modalSuccessExport;

  modalSuccessExportModal: NgbModalRef;
  modalExportSmsListModal: NgbModalRef;

  fc: UntypedFormControl = new UntypedFormControl('XLS', Validators.required);
  subaccount: UntypedFormControl = new UntypedFormControl();
  user: User | null;

  apiGetSmsSubaccountListHistoryOptions: ApiGetSmsSubaccountListHistoryOptions = {
    idSubaccount: null,
    dateFrom: null,
    dateTo: null
  };

  aggregableByCampain;

  private search: Subject<string> = new Subject();
  gridApi;
  gridColumnApi;
  tableLoading: boolean;
  tableHistoryGridOptions = null;
  tableColumnsDefs: any = [];
  paginationPageSize = 10;
  tableHistoryData;
  components = {
    smsDetailRederer: SmsDetailRenderComponent,
    buttonGroupRenderer: ButtonGroupRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };
  scrollPageSubs = 1;
  subaccounts: Array<Subaccount> = [];
  loadingPage = true;
  filter;
  today = new Date();
  dateFrom;
  dateTo;
  credits: any[];
  typeLabel;
  gridAnimationState = 'hide';
  constructor(
    private userService: UserService,
    private resellerHistoryService: ResellerHistoryService,
    private smsService: SmsService,
    private modalService: NgbModal,
    private subaccountService: SubaccountService,
    private translateService: TranslateService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.loaderService.show();

    this.userService.getAuthenticationState().subscribe(next => (this.user = next));

    this.defineTable();

    this.getSubaccounts();

    this.getCreditsType();

    //
  }

  private getSubaccounts() {
    this.subaccountService.getSubaccounts(null, null, null, null).subscribe(subs => {
      this.subaccounts = subs.data;
      this.subaccount.setValue(this.subaccounts[0].idUser);
      this.apiGetSmsSubaccountListHistoryOptions.idSubaccount = this.subaccount.value;
      this.gridOptionDefinition();
    });
  }

  getCreditsType() {
    this.smsService.getMessageTypes().subscribe(data => {
      this.credits = data.data.map(x => {
        return {
          value: x.id,
          icon: creditsTypeIcon[x.id],
          title: x.label
        };
      });
    });
  }

  getSubaccountList() {
    this.search.pipe(debounceTime(250)).subscribe(filter => {
      const body: ApiGetSubaccounts = {
        login: filter
      } as ApiGetSubaccounts;

      this.subaccountService.getSubaccounts(null, null, null, null, body).subscribe(subs => {
        this.subaccounts = subs.data;
      });
    });
  }

  onSearch($event) {
    this.search.next($event.term);
  }

  onScrollToEnd() {
    this.scrollPageSubs++;
    this.subaccountService.getSubaccounts(this.scrollPageSubs).subscribe(subs => {
      this.subaccounts = [...this.subaccounts, ...subs.data];
    });
  }

  onChange(event) {
    this.subaccount.setValue(event.idUser);
    this.apiGetSmsSubaccountListHistoryOptions.idSubaccount = event.idUser;
    this.grid.refresh();
  }

  defineTable() {
    this.tableColumnsDefs = [
      {
        headerNameTranslate: 'common_type',
        field: 'idMessageType',
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              this.translateService.get('credit_type_' + (params.data.idMessageType as string).toLowerCase()).subscribe(label => {
                this.typeLabel = label;
              });
              const icon = this.credits.filter(type => type.value === params.data.idMessageType);
              return (
                '<div class="type"><span>' +
                this.typeLabel +
                '</span> <img class="ml-2 info-icon" src="' +
                icon[0].icon +
                '" alt="" /> </div>'
              );
            } else {
              return '';
            }
          }
        },
        sortable: false
      },
      {
        headerNameTranslate: 'common_title',
        field: 'campaignName',
        cellRenderer: 'htmlRenderer',
        sortable: false,
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              return '<span class="campain-title color-primary">xxx</span>';
            }
            return '';
          }
        },
        onCellClicked: params => {
          this.openHistoryDetailModal(params.data.idMessage);
        },
        maxWidth: 90,
        cellStyle: { cursor: 'pointer', 'text-decoration': 'underline', color: '#067337', 'font-weight': 'bold', 'text-align': 'center' }
      },
      {
        headerNameTranslate: 'common_data_added',
        field: 'createTime',
        sortable: false,
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => (params && params.data ? formateDateTime(params.data.createTime) : '')
        }
      },
      {
        headerNameTranslate: 'common_data_sent',
        field: 'dateForSend',
        cellRenderer: 'htmlRenderer',
        sortable: false,
        cellRendererParams: {
          content: params => (params && params.data ? formateDateTime(params.data.dateForSend) : '')
        }
      },
      {
        headerNameTranslate: 'sender_sender',
        field: 'sender',
        sortable: false
      },
      {
        headerNameTranslate: 'list_sms_tablefield_sentfrom',
        field: 'sentFrom',
        sortable: false
      },
      {
        headerNameTranslate: 'common_number_recipient',
        field: 'recipients',
        sortable: false
      }
    ];
  }

  gridOptionDefinition() {
    const that = this;
    const key = 'period';

    this.tableHistoryGridOptions = AtlasGridOptions.deserialize({
      onGridReady: (event: GridReadyEvent) => {
        this.filter = this.grid.filtersModel[key];
        this.loadData();
        this.grid.dataIsLoaded.subscribe(() => {
          this.gridAnimationState = 'show';
        });
        this.grid.exportGlobal.subscribe(value => {
          this.export();
        });
      },
      onFilterChange: (event: any) => {
        if (event?.type === 'period') {
          this.onFilterChange(event.value);
          this.grid.filter();
        } else {
          this.buildDate();
        }
      },
      pagination: true,
      export: 'export',
      exportText: 'reseller_history_export_time_help',
      exportButtons: [{ label: 'sms_detail_export_export', value: 'true' }],
      paginationPageSize: this.paginationPageSize,
      filters: this.getFilters(this.tableHistoryData),
      loadFunction: this.reloadList.bind(that),

      noRowsOverlayOptions: {
        message: ''
      }
    });
  }

  loadData() {
    this.grid.filtersModel[filterKey.period] = {
      label: 'timefilter_dates_thismonth',
      value: 'thismonth',
      translate: true
    };
    this.onFilterChange('thismonth');
    this.grid.refresh();
  }

  reloadList(startRow?, endRow?, sort?) {
    this.loadingPage ? (this.loadingPage = false) : this.loaderService.show();

    return this.resellerHistoryService
      .getListSmsSentList(
        this.apiGetSmsSubaccountListHistoryOptions,
        1 + startRow / (endRow - startRow),
        endRow - startRow,
        sort && sort.length ? sort[0].colId : null,
        sort && sort.length ? (sort[0].sort === 'desc' ? 'd' : 'a') : null
      )
      .pipe(finalize(() => this.loaderService.hide()));
  }

  buildDate() {
    const today = new Date();
    const offset = moment(today).utcOffset();
    let timezone;

    if (offset < 0) {
      timezone =
        '-' +
        today
          .toString()
          .split('-')[1]
          .split(' ')[0];
    } else {
      timezone =
        '+' +
        today
          .toString()
          .split('+')[1]
          .split(' ')[0];
    }

    const dateFrom =
      moment(this.grid.filtersModel[filterKey.fromDateKey])
        .format()
        .split('T')[0] +
      'T' +
      this.grid.filtersModel[filterKey.fromTimeKey] +
      ':00' +
      timezone;
    const dateTo =
      moment(this.grid.filtersModel[filterKey.toDateKey])
        .format()
        .split('T')[0] +
      'T' +
      this.grid.filtersModel[filterKey.toTimeKey] +
      ':00' +
      timezone;
    this.apiGetSmsSubaccountListHistoryOptions.dateFrom = dateFrom;
    this.apiGetSmsSubaccountListHistoryOptions.dateTo = dateTo;
    this.apiGetSmsSubaccountListHistoryOptions.idSubaccount = this.subaccount.value;
  }

  getFilters(tableHistoryData) {
    return [
      {
        name: 'period',
        label: 'common_from',
        type: 'dropdown',
        options: [
          {
            label: 'timefilter_dates_last6months',
            value: 'all',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_lasthour',
            value: 'lastHour',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_last24hours',
            value: 'last24hours',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_today',
            value: 'today',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_thisweek',
            value: 'thisweek',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_thismonth',
            value: 'thismonth',
            translate: true,
            type: 'period'
          },
          {
            label: 'timefilter_dates_lastmonth',
            value: 'lastmonth',
            translate: true,
            type: 'period'
          }
        ]
      },
      {
        name: 'fromDate',
        label: 'common_from',
        type: 'date'
      },
      {
        name: 'fromTime',
        label: 'common_from',
        type: 'time'
      },
      {
        name: 'toDate',
        label: 'common_to',
        type: 'date'
      },
      {
        name: 'toTime',
        label: 'common_from',
        type: 'time'
      }
    ];
  }

  getApiGetSmsListOptions() {
    const apiGetSmsSubaccountListHistoryOptions: ApiGetSmsSubaccountListHistoryOptions = {
      idSubaccount: null,
      dateFrom: null,
      dateTo: null
    };
    const offset = moment(this.today).utcOffset();
    let timezone;
    if (offset < 0) {
      timezone =
        '-' +
        this.today
          .toString()
          .split('-')[1]
          .split(' ')[0];
    } else {
      timezone =
        '+' +
        this.today
          .toString()
          .split('+')[1]
          .split(' ')[0];
    }

    const dateFrom = moment(this.grid.filtersModel[filterKey.fromDateKey]).format();
    const dateTo = this.grid.filtersModel[filterKey.toDateKey] + 'T' + this.grid.filtersModel[filterKey.toTimeKey] + +':00' + timezone;
    apiGetSmsSubaccountListHistoryOptions.dateFrom = dateFrom;
    apiGetSmsSubaccountListHistoryOptions.dateTo = dateTo;
    apiGetSmsSubaccountListHistoryOptions.idSubaccount = this.subaccount.value;
    return apiGetSmsSubaccountListHistoryOptions;
  }

  onFilterChange(filter) {
    let dateFrom;

    switch (filter) {
      case 'all':
        dateFrom = new Date(null);

        break;
      case 'lastHour':
        dateFrom = moment()
          .subtract(1, 'hour')
          .format();

        break;

      case 'last24hours':
        dateFrom = moment()
          .subtract(24, 'hour')
          .format();

        break;

      case 'today':
        dateFrom = moment()
          .startOf('day')
          .format();

        break;

      case 'thisweek':
        dateFrom = moment()
          .startOf('isoWeek')
          .format();

        break;

      case 'thismonth':
        dateFrom = moment()
          .startOf('month')
          .format();

        break;

      case 'lastmonth':
        dateFrom = moment()
          .startOf('month')
          .subtract(1, 'month')
          .format();

        break;
      default:
        break;
    }

    const newDate = new Date(
      moment(dateFrom)
        .format('ddd MMM DD YYYY HH:mm:ss')
        .toString()
    );

    this.apiGetSmsSubaccountListHistoryOptions.dateFrom = moment(dateFrom).format('YYYY-MM-DDTHH:mm:ssZZ');
    this.apiGetSmsSubaccountListHistoryOptions.dateTo = moment().format('YYYY-MM-DDTHH:mm:ssZZ');

    this.setFilters(newDate, dateFrom);
  }

  private setFilters(newDate: Date, dateFrom: any) {
    this.grid.filtersModel[filterKey.fromDateKey] = newDate;
    this.grid.filtersModel[filterKey.fromTimeKey] = moment(dateFrom).format('HH:mm');
    this.grid.filtersModel[filterKey.toDateKey] = this.today;
    this.grid.filtersModel[filterKey.toTimeKey] = moment(this.today).format('HH:mm');
  }

  openHistoryDetailModal(idMessage) {
    const options: NgbModalOptions = {
      size: 'lg',
      windowClass: 'custom-history-detail-modal-height'
    };
    const landingPageModal = this.modalService.open(HistoryDetailModalComponent, options);
    (landingPageModal.componentInstance as HistoryDetailModalComponent).idMessage = idMessage;
    const idSub = this.apiGetSmsSubaccountListHistoryOptions.idSubaccount;
    (landingPageModal.componentInstance as HistoryDetailModalComponent).idSubaccount = idSub;
  }

  export() {
    this.resellerHistoryService
      .exportSendSmsList(this.fc.value, this.apiGetSmsSubaccountListHistoryOptions, this.aggregableByCampain)
      .subscribe(success => {
        this.modalService.dismissAll();
        this.openModalSuccessExport();
      });
  }

  openExportModal(): void {
    this.modalExportSmsListModal = this.modalService.open(this.modalExportSmsList);
    this.modalExportSmsListModal.result.then(
      result => {},
      reason => {}
    );
  }

  openModalSuccessExport(): void {
    this.modalSuccessExportModal = this.modalService.open(this.modalSuccessExport);
    this.modalSuccessExportModal.result.then(
      result => {
        this.modalService.dismissAll();
      },
      reason => {
        this.modalService.dismissAll();
      }
    );
  }
}
